<template>
  <div class="education">
    <div class="container">
      <div class="" v-on-scroll="{animation: 'header'}">
        <h3 class="wow">For Businesses</h3>
        <hr class="wow">
      </div>
      <div class="content">
        <div class="row">
          <div class="col-md-4">
            <div class="right-s">
              <div class="gv"></div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="text-center" v-on-scroll="{animation: 'left-s'}">
              <img src="@/assets/gvLearning/img/unsplash_g1Kr4Ozfoac.png" v-on-scroll="{animation: 'slideInLeft'}"
                   alt="eduction" class="wow">
              <div class="row offset-md-5 col-md-3">
                <router-link to="/businesses-registration" class="wow" v-on-scroll="{animation: 'swing'}" style="top: 0; right: 34px;">
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <div class='line'></div>
                  <span>GV Business</span>

                  <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.41406" width="15" height="2" transform="rotate(45 1.41406 0)" fill="white"/>
                    <rect y="19.7988" width="15" height="2" transform="rotate(-45 0 19.7988)" fill="white"/>
                  </svg>
                </router-link>
              </div>
              <div class="wow" v-on-scroll="{animation: 'desc'}">
                <p>
                  <strong>The perk your employees want</strong> . With GV Learning for Teams, you're giving employees
                  the power of choice. Everything you need to deliver high-impact training that accelerates business
                  growth to creativity outlets for the team.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <hr class="h-line">
</template>

<style lang="scss" scoped>
@import "~@/assets/gvLearning/styles.scss";
@import "~@/assets/gvLearning/education.scss";

.swing {
  -webkit-animation: swing;
  animation: swing;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.slideInLeft {
  -webkit-animation: slideInLeft;
  animation: slideInLeft;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

.education {
  background-image: url('~@/assets/gvLearning/img/unsplash_dKd3p6gha-c.png');
  box-shadow: none;
  background-size: cover;
  background-repeat: no-repeat;
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 44px 0px 230px 0px;
    background-color: #FFF;
  }

  .header {
    h3 {
      color: #000;
    }

    hr {
      background-color: #000;
    }

  }

  .content {
    .left-s {

      img {

      }

      a {
        background: linear-gradient(270deg, #141414 -13.62%, #505050 160.12%);
        @media (min-width: $width1) and (max-width: $width2) {
          top: 93px;
        }

        .line {
          background: #FFF;
        }
      }

      .desc {
        background: linear-gradient(91.29deg, #00AC5D -16.43%, #007644 100.41%);
        left: -252px;
        right: unset;
        @media (min-width: $width1) and (max-width: $width2) {
          left: 28px;
          width: 93%;
          padding: 20px 22px;
          bottom: -79px;
        }

        p {
          color: #fff;
        }
      }
    }
  }
}

.h-line {
  width: 100%;
  height: 4px;
  opacity: 1;
  background: #1A191D;
  transform: matrix(1, 0, 0, -1, 0, 0);
  margin: 0;
  padding: 0;
  @media (min-width: $width1) and (max-width: $width2) {
    height: 6px;
  }
}
</style>
